var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem",value:(_vm.body),expression:"body"}]},[_c('i-count-up',{attrs:{"start":_vm.start,"end":_vm.end,"decimals":_vm.decimals,"duration":_vm.duration,"options":_vm.options,"callback":_vm.callback}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.postfix)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43067b64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CounterUp.vue
// module id = null
// module chunks = 